import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';

export default class AutocompleteInput extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Autocomplete
                    inputProps={this.props.inputProps}
                    disabled={this.props.type}
                    value={this.props.value}
                    wrapperStyle={this.props.wrapperStyle}
                    items={this.props.items}
                    getItemValue={this.props.getItemValue}
                    onSelect={this.props.onSelect}
                    onChange={this.props.onChange}
                    renderMenu={this.props.renderMenu}
                    renderItem={this.props.renderItem}
                />
            </>);
    }
}
